import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonDirective, ButtonLabel } from 'primeng/button';
import { Ripple } from 'primeng/ripple';

@Component({
  selector: 'au-onboarding-responsive-welcome',
  templateUrl: './onboarding-responsive-welcome.component.html',
  styleUrls: ['./onboarding-responsive-welcome.component.scss'],
  imports: [Ripple, ButtonDirective, ButtonLabel],
})
export class OnboardingResponsiveWelcomeComponent {
  mercuryLogoPath = 'assets/images/logo-original.svg';

  constructor(private router: Router) {}

  sendToOnboardingForm() {
    this.router.navigateByUrl('onboarding/form/yes');
  }
}
